import React, { useState, useEffect } from 'react';

import { useLinkTo, useMount, useUserStateRedux } from '../../../../hooks';
import analytics from '../../../../modules/analytics';
import {
  getProAppointmentDetails,
  ProAppointmentDetails,
} from '../../../../api/Providers/Appointments';
import { PROVIDER_SEARCH_RANK } from '../../../../route-names';

import NcdPaymentAppointmentNotification, {
  NotificationProps,
} from './NcdPaymentAppointmentNotification';

type NcdPaymentAppointmentNotificationContainerProps = {
  notification: NotificationProps;
};

const NcdPaymentAppointmentNotificationContainer:
React.FC<NcdPaymentAppointmentNotificationContainerProps> = ({
  notification,
}) => {
  const { provider_id, appointment_id } = notification;
  const [
    shouldHideNotification,
    hideNotification,
    shouldHideNotificationLoaded,
  ] = useUserStateRedux(`ncd-payment-appointment-notification-${appointment_id}`);
  const [appointment, setAppointment] = useState<ProAppointmentDetails | null>(null);
  const [canShow, setCanShow] = useState<boolean>(false);
  const linkTo = useLinkTo();

  const loadAppointment = async () => {
    const rawAppointment = await getProAppointmentDetails(
      Number(provider_id), Number(appointment_id),
    );
    setAppointment(rawAppointment);
  };

  const handleCTAClick = () => {
    analytics.track('Paid Ncd Appointment Notification See Current Score Clicked', {
      provider_id,
      appointment_id,
    });
    hideNotification(true);
    setCanShow(false);
    linkTo(PROVIDER_SEARCH_RANK, {
      providerId: provider_id,
      source: 'notification',
    });
  };

  useMount(() => {
    analytics.track('Paid Ncd Appointment Notification Viewed', {
      provider_id,
      appointment_id,
    });
    loadAppointment();
  });

  useEffect(() => {
    if (!shouldHideNotificationLoaded || shouldHideNotification || appointment === null) return;
    setCanShow(true);
  }, [
    shouldHideNotificationLoaded,
    shouldHideNotification,
    notification,
    appointment,
  ]);

  return (
    canShow && (
      <NcdPaymentAppointmentNotification
        notification={notification}
        onCTAClick={handleCTAClick}
        clientName={appointment.client.name}
      />
    )
  );
};

export default NcdPaymentAppointmentNotificationContainer;
